var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-element-loading',{attrs:{"active":_vm.loading,"is-full-screen":"","background-color":"#FFF","text":"loading...","text-style":{ color: 'grey', margin: '-40px 0 0 0' }}},[_c('img',{attrs:{"src":_vm.loadingGif,"width":"150px","height":"150px","alt":"loading"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }